import { apiClient } from '../../../api/client'
/** Utilidades puras de la vista archivistica. Fuera de `ui.tsx` para que ese modulo
 *  exporte solo componentes (react-refresh). */

export function formatBytes(bytes: number | null): string {
  if (bytes == null) return '—'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

/**
 * Peso en KB, que es la unidad en la que se lee un indice de expediente: un
 * documento de 0 KB no existe, asi que por debajo de 1 KB se redondea a 1 en
 * lugar de mostrar "0".
 */
export function formatKb(bytes: number | null): string {
  if (bytes == null) return '—'
  const kb = bytes / 1024
  return kb < 1 ? '1' : String(Math.round(kb))
}

/** "1" para un folio suelto, "2–4" para un rango. El guion es un en-dash, no un menos. */
export function folioRange(desde: number, hasta: number): string {
  if (hasta <= desde) return String(desde)
  return `${desde}–${hasta}`
}

/**
 * Descarga autenticada. El endpoint no acepta el token por querystring, así que hay
 * que pasar por `fetch` y volcar el blob en un enlace temporal.
 */
export async function downloadAuthenticated(url: string, filename: string): Promise<void> {
  const response = await apiClient.fetchAuthorized(url)
  if (!response.ok) throw new Error(`Download failed: ${response.status}`)
  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(blobUrl)
}
